import CourseCertificates from './CourseCertificates';

const AddCourseCertificates = ({ id }: { id: number }) => {
  return <CourseCertificates id={id} />;
};

export default AddCourseCertificates;
